"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestHeaders = void 0;
var RequestHeaders;
(function (RequestHeaders) {
    RequestHeaders["AUTHORIZATION"] = "Authorization";
    RequestHeaders["ACT_AS_USER"] = "Act-As-User";
    RequestHeaders["PRODUCT_TYPE"] = "Product-Type";
    RequestHeaders["RESPONSE_LANGUAGE"] = "Response-Language";
})(RequestHeaders = exports.RequestHeaders || (exports.RequestHeaders = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC1oZWFkZXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbW1vbi9lbnVtcy9yZXF1ZXN0LWhlYWRlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUgsSUFBWSxjQUtYO0FBTEQsV0FBWSxjQUFjO0lBQ3hCLGlEQUErQixDQUFBO0lBQy9CLDZDQUEyQixDQUFBO0lBQzNCLCtDQUE2QixDQUFBO0lBQzdCLHlEQUF1QyxDQUFBO0FBQ3pDLENBQUMsRUFMVyxjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQUt6QiJ9